var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showLoggedArea)?_c('c-menu'):_vm._e(),_c('div',{class:{'wrapper-pages': _vm.showLoggedArea}},[_c('router-view')],1),(_vm.showLoggedArea)?_c('c-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }